import type { NotificationsQueryParams } from '../types';

export const NOTIFICATION_KEYS = {
  all: ['notifications'] as const,
  list: (params: NotificationsQueryParams) => ['notifications', 'list', params] as const,
};
